<template>
  <div class="dict-data">
    <page-header title="字典数据" icon="el-icon-notebook-2">
      <template #breadcrumb>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/system/dict' }">字典管理</el-breadcrumb-item>
          <el-breadcrumb-item>字典数据</el-breadcrumb-item>
        </el-breadcrumb>
      </template>
    </page-header>

    <!-- 操作按钮区 -->
    <div class="table-operations">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      <el-button icon="el-icon-back" @click="handleBack">返回</el-button>
    </div>

    <!-- 表格区域 -->
    <el-table
      :data="tableData"
      border
      row-key="dictCode"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column prop="dictLabel" label="字典标签" align="center"></el-table-column>
      <el-table-column prop="dictValue" label="字典键值" align="center"></el-table-column>
      <el-table-column prop="dictSort" label="字典排序" width="100" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === '1' ? 'success' : 'info'">
            {{ scope.row.status === '1' ? '正常' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
      <el-table-column label="操作" width="240" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleAddChild(scope.row)">增加</el-button>
          <el-button type="text" @click="handleEdit(scope.row)">修改</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>

    <!-- 统一的新增/修改对话框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="500px"
      append-to-body>
      <el-form 
        ref="form" 
        :model="form" 
        :rules="rules" 
        label-width="80px">
        <el-form-item label="字典类型" prop="dictType">
          <el-input v-model="form.dictType" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="上级目录" prop="parentId" v-if="dialogTitle !== '添加字典数据'">
          <el-select
            v-model="form.parentId"
            placeholder="请选择上级目录"
            filterable
            style="width: 100%">
            <el-option
              v-for="item in parentOptions"
              :key="item.dictCode"
              :label="item.dictLabel"
              :value="item.dictCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据标签" prop="dictLabel">
          <el-input v-model="form.dictLabel" placeholder="请输入数据标签"></el-input>
        </el-form-item>
        <el-form-item label="数据键值" prop="dictValue">
          <el-input v-model="form.dictValue" placeholder="请输入数据键值"></el-input>
        </el-form-item>
        <el-form-item label="显示排序" prop="dictSort">
          <el-input-number 
            v-model="form.dictSort" 
            :min="0" 
            :max="999"
            controls-position="right">
          </el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio label="1">正常</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="备注">
          <el-input 
            type="textarea" 
            v-model="form.remark" 
            placeholder="请输入内容"
            :rows="4">
          </el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/common/PageHeader.vue'
import request from '@/utils/request'

export default {
  name: 'DictData',
  components: {
    PageHeader
  },
  data() {
    return {
      currentDict: {
        dictId: '',
        dictType: '',
        dictName: ''
      },
      tableData: [],
      selectedRows: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '',
      form: {
        dictId: '',
        dictType: '',
        dictLabel: '',
        dictValue: '',
        dictSort: 0,
        status: '1',
        remark: '',
        dictItemId: '',
        parentId: ''
      },
      parentOptions: [],
      rules: {
        dictLabel: [
          { required: true, message: '请输入数据标签', trigger: 'blur' }
        ],
        dictValue: [
          { required: true, message: '请输入数据键值', trigger: 'blur' }
        ],
        dictSort: [
          { required: true, message: '请输入显示排序', trigger: 'blur' }
        ],
        parentId: [
          { required: false, message: '请选择上级目录', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    // 从路由参数中获取字典信息
    const { dictId, dictType, dictName } = this.$route.params
    this.currentDict = {
      dictId,
      dictType,
      dictName
    }
    // 获取字典数据列表
    this.fetchData()
  },
  methods: {
    // 获取字典数据列表
    async fetchData() {
      try {
        const res = await request({
          url: `/api/v1/dict/item/list`,
          method: 'POST',
          data: {
            dictId: this.currentDict.dictId
          }
        })
        
        if (res.status === 1 && res.data) {
          // 转换为树形结构
          this.tableData = this.buildTree(res.data)
        }
      } catch (error) {
        console.error('获取字典数据列表错误:', error)
        this.$message.error('获取字典数据列表失败')
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    handleAdd() {
      this.dialogTitle = '添加字典数据'
      this.form = {
        dictId: this.currentDict.dictId,
        dictType: this.currentDict.dictType,
        dictLabel: '',
        dictValue: '',
        dictSort: 0,
        status: '1',
        remark: '',
        dictItemId: '',
        parentId: '0'  // 顶级节点的 parentId 设为 '0'
      }
      this.parentOptions = []  // 顶级添加不需要父节点选项
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form?.resetFields()
      })
    },
    handleAddChild(row) {
      this.dialogTitle = '添加子级数据'
      this.form = {
        dictId: this.currentDict.dictId,
        dictType: this.currentDict.dictType,
        dictLabel: '',
        dictValue: '',
        dictSort: 0,
        status: '1',
        remark: '',
        dictItemId: '',
        parentId: row.dictCode  // 设置父级ID为当前行的ID
      }
      this.dialogVisible = true
      this.getParentOptions(row)  // 传入当前行，只显示当前行作为父节点选项
      this.$nextTick(() => {
        this.$refs.form?.resetFields()
      })
    },
    handleModify() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning('请选择一条记录进行修改')
        return
      }
      this.handleEdit(this.selectedRows[0])
    },
    handleEdit(row) {
      this.dialogTitle = '修改字典数据'
      this.form = {
        dictId: this.currentDict.dictId,
        dictType: this.currentDict.dictType,
        dictLabel: row.dictLabel,
        dictValue: row.dictValue,
        dictSort: row.dictSort,
        status: row.status,
        remark: row.remark,
        dictItemId: row.dictCode,
        parentId: row.parentId || ''
      }
      this.dialogVisible = true
      this.getParentOptions(row, true)  // 编辑模式，传入当前行和编辑标志
    },
    // 删除字典数据
    async handleDelete(row) {
      try {
        await this.$confirm('是否确认删除该字典数据?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await request({
          url: `/api/v1/dict/item/delete`,
          // url: `/api/v1/sys-dict/${this.currentDict.dictId}/item/delete`,
          method: 'POST',
          data: {
            dictId: this.currentDict.dictId,
            itemId: row.dictCode
          }
        })

        if (res.status === 1) {
          this.$message.success(res.msg || '删除成功')
          this.fetchData() // 刷新表格数据
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {  // 排除用户取消的情况
          console.error('删除字典数据错误:', error)
          this.$message.error('删除失败')
        }
      }
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    },
    async submitForm() {
      try {
        await this.$refs.form.validate()
        const res = await request({
          url: `/api/v1/dict/item/save`,
          method: 'POST',
          data: {
            dictId: this.form.dictId,
            dictItemId: this.form.dictItemId,
            dictItemName: this.form.dictLabel,
            dictItemValue: this.form.dictValue,
            dictItemStatus: parseInt(this.form.status),
            parentId: this.form.parentId || '0',
            sort: this.form.dictSort
          }
        })

        if (res.status === 1) {
          this.$message.success(this.form.dictItemId ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.fetchData()
        }
      } catch (error) {
        console.error('保存字典数据错误:', error)
        this.$message.error(this.form.dictItemId ? '修改失败' : '新增失败')
      }
    },
    async getParentOptions(currentRow = null, isEdit = false) {
      try {
        const res = await request({
          url: '/api/v1/dict/item/list',
          method: 'POST',
          data: {
            dictId: this.currentDict.dictId
          }
        })

        if (res.status === 1 && res.data) {
          const allNodes = res.data.map(item => ({
            dictCode: item.item_id,
            dictLabel: item.item_label,
            dictValue: item.item_value,
            parentId: item.parent_id || '0'
          }))

          let filteredOptions = []

          if (currentRow === null) {
            // 顶级添加：只显示顶级节点（parent_id 为 '0'）
            filteredOptions = allNodes.filter(item => item.parentId === '0')
          } else if (isEdit) {
            // 编辑模式：显示同级节点（相同 parentId）和父级节点
            const currentParentId = currentRow.parentId || '0'

            // 获取同级节点
            const siblings = allNodes.filter(item =>
              item.parentId === currentParentId &&
              item.dictCode !== currentRow.dictCode
            )

            // 获取父级节点（如果不是顶级）
            let parentNode = null
            if (currentParentId !== '0') {
              parentNode = allNodes.find(item => item.dictCode === currentParentId)
            }

            // 组合选项
            filteredOptions = parentNode ? [parentNode, ...siblings] : siblings

            // 排除当前节点的所有子孙节点
            const excludeIds = this.getDescendantIds(currentRow.dictCode, allNodes)
            filteredOptions = filteredOptions.filter(item => !excludeIds.includes(item.dictCode))
          } else {
            // 添加子级：只显示当前节点
            filteredOptions = [{
              dictCode: currentRow.dictCode,
              dictLabel: currentRow.dictLabel,
              dictValue: currentRow.dictValue || '',
              parentId: currentRow.parentId || '0'
            }]
          }

          this.parentOptions = filteredOptions
        }
      } catch (error) {
        console.error('获取上级目录列表失败:', error)
        this.$message.error('获取上级目录列表失败')
      }
    },
    // 递归获取所有子孙节点的ID
    getDescendantIds(parentId, allNodes) {
      const descendants = []
      const children = allNodes.filter(node => node.parentId === parentId)

      children.forEach(child => {
        descendants.push(child.dictCode)
        // 递归获取子节点的子节点
        const grandChildren = this.getDescendantIds(child.dictCode, allNodes)
        descendants.push(...grandChildren)
      })

      return descendants
    },
    formatDateTime(date) {
      if (!date) return ''
      const d = new Date(date)
      
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      const second = String(d.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    handleBack() {
      this.$router.push('/system/dict')
    },
    // 添加构建树形结构的方法
    buildTree(data) {
      // 格式化数据
      const formattedData = data.map(item => ({
        dictCode: item.item_id,
        dictLabel: item.item_label,
        dictValue: item.item_value,
        dictSort: item.sort || 0,
        status: item.status.toString(),
        createTime: this.formatDateTime(item.created_at),
        parentId: item.parent_id || '0',
        children: []
      }))

      // 创建字典表，方便查找
      const dict = {}
      formattedData.forEach(item => {
        dict[item.dictCode] = item
      })

      // 构建树形结构
      const result = []
      formattedData.forEach(item => {
        if (item.parentId === '0') {
          // 顶级节点直接加入结果数组
          result.push(item)
        } else {
          // 将当前节点添加到父节点的children中
          const parent = dict[item.parentId]
          if (parent) {
            parent.children = parent.children || []
            parent.children.push(item)
          }
        }
      })

      // 排序
      const sortTree = (nodes) => {
        nodes.sort((a, b) => a.dictSort - b.dictSort)
        nodes.forEach(node => {
          if (node.children && node.children.length > 0) {
            sortTree(node.children)
          }
        })
      }
      sortTree(result)

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.dict-data {
  padding: 20px;

  .table-operations {
    margin-bottom: 16px;
    
    .el-button {
      margin-right: 8px;
    }
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }

  // 表格样式
  .el-table {
    margin: 15px 0;
    
    // 调整表头样式
    ::v-deep .el-table__header-wrapper {
      th {
        background-color: #f5f7fa;
        color: #606266;
        font-weight: 600;
        text-align: center;
      }
    }
    
    // 调整单元格样式
    ::v-deep .el-table__body-wrapper {
      td {
        padding: 12px 0;
      }
    }
    
    // 调整操作按钮间距
    .el-button--text {
      padding: 0 8px;
    }
  }
}
</style> 